
/**
 * Format a number with commas as thousand separators
 * @param num - The number to format
 * @returns Formatted string with commas
 */
export const formatNumberWithCommas = (num: number): string => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

/**
 * Calculate the tradeable AUM (Assets Under Management) based on credits
 * 1 credit = $1,000 of tradeable AUM
 * @param credits - The number of credits
 * @returns Formatted string representing tradeable AUM in dollars
 */
export const calculateTradeableAUM = (credits: number): string => {
  const aumValue = credits * 1000;
  return `$${formatNumberWithCommas(aumValue)}`;
};

/**
 * Predefined credit packages available for purchase
 */
export const creditPackages = [
  {
    id: 'basic',
    name: 'Basic',
    amount: 1000,
    price: 1000,
    popular: false,
    stripePriceId: 'price_basic'
  },
  {
    id: 'standard',
    name: 'Standard',
    amount: 10000,
    price: 10000,
    popular: true,
    stripePriceId: 'price_standard'
  },
  {
    id: 'premium',
    name: 'Premium',
    amount: 25000,
    price: 25000,
    popular: false,
    stripePriceId: 'price_premium'
  }
];
